import { TCronGeneratorTab, TFieldName } from './cronGeneratorContext';

export enum CronGeneratorActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FIELD_VALUE = 'SET_FIELD_VALUE',
}

interface IChangeVisibleForm {
	type: CronGeneratorActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCronGeneratorTab;
	};
}

interface ISetFieldValue {
	type: CronGeneratorActionTypes.SET_FIELD_VALUE;
	payload: {
		fieldName: TFieldName;
		value: string;
	};
}

export type TCronGeneratorAction = IChangeVisibleForm | ISetFieldValue;
